// Navbar scroll behaviour
(function () {
  const navbar = document.querySelector('.theme__header');
  if (!navbar) return;

  let lastScrollTop = 0;

  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;

    if (scrollTop <= 50) {
      navbar.classList.remove('active', 'bgcolor');
    } else if (scrollTop > lastScrollTop) {
      navbar.classList.add('active', 'bgcolor');
    } else {
      navbar.classList.remove('active');
    }

    lastScrollTop = scrollTop;
  }, { passive: true });
})();

// Swiper — PDP thumbnails
// No loop: the rail has a real first and last slide, so Swiper can mark the up/down
// buttons swiper-button-disabled at the ends and CSS hides them.
const swiperThumbs = new Swiper('.thumb-swiper', {
  spaceBetween: 8,
  slidesPerView: 4,
  freeMode: true,
  direction: 'vertical',
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.thumb-swiper__nav--down',
    prevEl: '.thumb-swiper__nav--up',
  },
  breakpoints: {
    320: { slidesPerView: 4 },
    768: { slidesPerView: 4 },
    1024: { slidesPerView: 4 },
    1440: { slidesPerView: 4 },
  },
});

// No loop: with dots as the only affordance, wrapping past the last image would leave the
// active bullet jumping back to the first with nothing to explain the jump.
const swiperMain = new Swiper('.swiper.main-swiper', {
  slidesPerView: 1,
  spaceBetween: 16,
  pagination: {
    el: '.swiper-pagination-main',
    clickable: true,
  },
  thumbs: {
    swiper: swiperThumbs,
  },
  breakpoints: {
    320: { slidesPerView: 1, spaceBetween: 10 },
    499: { slidesPerView: 1, spaceBetween: 16 },
  },
});

// Image lightbox — vanilla JS (reuses existing mfp-* CSS in tlpc_pdp.css)
(function initImageGallery() {
  var galleryWrapper = document.querySelector('.img-gallery-magnific');
  if (!galleryWrapper) return;

  // Images and videos in one list, built in DOM order so the counter and the arrows follow
  // the same sequence as the on-page gallery. One selector for both keeps that ordering —
  // querySelectorAll returns document order regardless of how the selectors are written.
  var triggers = galleryWrapper.querySelectorAll(
    '.image-popup-vertical-fit:not(.swiper-slide-duplicate .image-popup-vertical-fit), ' +
    '[data-lightbox-video]:not(.swiper-slide-duplicate [data-lightbox-video])'
  );
  var items = [];
  triggers.forEach(function (trigger) {
    if (trigger.dataset.lightboxVideo) {
      items.push({
        type: 'video',
        src: trigger.dataset.lightboxVideo,
        poster: trigger.dataset.lightboxPoster || '',
        alt: '',
        title: ''
      });
      return;
    }

    var img = trigger.querySelector('img');
    items.push({
      type: 'image',
      src: trigger.href,
      alt: img ? (img.alt || '') : '',
      title: trigger.getAttribute('title') || ''
    });
  });

  if (!items.length) return;

  // Build overlay DOM (matches mfp-* classes so existing CSS applies)
  var overlay = document.createElement('div');
  overlay.className = 'mfp-container mfp-s-ready mfp-image-holder';
  overlay.style.display = 'none';
  overlay.innerHTML =
    '<div class="mfp-content">' +
      '<figure>' +
        '<img class="mfp-img" src="" alt="">' +
        // preload="none" so no bytes move until a video item is actually shown.
        '<video class="mfp-video" controls playsinline preload="none" style="display:none"></video>' +
        '<figcaption><div class="mfp-title"></div></figcaption>' +
      '</figure>' +
    '</div>' +
    '<div class="mfp-counter"></div>' +
    '<button class="mfp-close" type="button" aria-label="Close image gallery"></button>' +
    '<button class="mfp-arrow mfp-arrow-left" type="button" aria-label="Previous image"></button>' +
    '<button class="mfp-arrow mfp-arrow-right" type="button" aria-label="Next image"></button>';
  document.body.appendChild(overlay);

  var imgEl = overlay.querySelector('.mfp-img');
  var videoEl = overlay.querySelector('.mfp-video');
  var counterEl = overlay.querySelector('.mfp-counter');
  var titleEl = overlay.querySelector('.mfp-title');
  var closeBtn = overlay.querySelector('.mfp-close');
  var prevBtn = overlay.querySelector('.mfp-arrow-left');
  var nextBtn = overlay.querySelector('.mfp-arrow-right');
  var currentIndex = 0;
  var triggerEl = null;

  // Dropping the src and reloading is what actually stops the download — pause alone leaves
  // the stream buffering, and a paused video with a src keeps audio ready to resume.
  function stopVideo() {
    if (!videoEl.getAttribute('src')) return;
    videoEl.pause();
    videoEl.removeAttribute('src');
    videoEl.load();
  }

  function showItem(index) {
    currentIndex = index;
    var item = items[index];

    // Unconditional: navigating away from a video must silence it before the swap.
    stopVideo();

    if (item.type === 'video') {
      imgEl.style.display = 'none';
      videoEl.style.display = '';
      videoEl.poster = item.poster;
      videoEl.src = item.src;
      // Unmuted with controls, unlike the muted inline slide. play() is called off the click
      // that opened the lightbox so autoplay policy allows it; if it is still refused the
      // controls are already there for the user to start it.
      videoEl.play().catch(function () {});
    } else {
      videoEl.style.display = 'none';
      imgEl.style.display = '';
      imgEl.src = item.src;
      imgEl.alt = item.alt;
    }

    titleEl.textContent = item.title;
    counterEl.textContent = (index + 1) + ' / ' + items.length;

    if (items.length <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    } else {
      prevBtn.style.display = '';
      nextBtn.style.display = '';
    }
  }

  function openGallery(index) {
    showItem(index);
    overlay.style.display = '';
    document.body.style.overflow = 'hidden';
  }

  function closeGallery() {
    stopVideo();
    overlay.style.display = 'none';
    document.body.style.overflow = '';
    if (triggerEl) {
      triggerEl.focus();
      triggerEl = null;
    }
  }

  // Click delegation on gallery wrapper — works for originals and Swiper clones
  galleryWrapper.addEventListener('click', function (e) {
    var trigger = e.target.closest('.image-popup-vertical-fit, [data-lightbox-video]');
    if (!trigger) return;
    e.preventDefault();
    triggerEl = trigger;

    // Match by source rather than element identity, so a Swiper clone resolves to the same
    // item as the original it was cloned from.
    var src = trigger.dataset.lightboxVideo || trigger.href;
    var index = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].src === src) { index = i; break; }
    }
    openGallery(index);
  });

  closeBtn.addEventListener('click', closeGallery);

  prevBtn.addEventListener('click', function () {
    showItem((currentIndex - 1 + items.length) % items.length);
  });

  nextBtn.addEventListener('click', function () {
    showItem((currentIndex + 1) % items.length);
  });

  // Close on backdrop click (not on image/buttons)
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || e.target.classList.contains('mfp-content')) {
      closeGallery();
    }
  });

  // Keyboard navigation
  document.addEventListener('keydown', function (e) {
    if (overlay.style.display === 'none') return;
    if (e.key === 'Escape') closeGallery();
    // With the video focused the arrow keys are its own seek controls — navigating the gallery
    // as well would scrub and change slide off one press.
    if (e.target === videoEl) return;
    if (e.key === 'ArrowLeft') showItem((currentIndex - 1 + items.length) % items.length);
    if (e.key === 'ArrowRight') showItem((currentIndex + 1) % items.length);
  });
})();

// Floating PDP video card — dismiss
// Removed rather than hidden: a hidden <video> keeps playing and keeps pulling bytes in some
// browsers. Pause first, then detach. Deliberately not persisted — it returns on next load.
document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('.pdp-video-card__close');
  if (!closeButton) return;

  const card = closeButton.closest('.pdp-video-card');
  if (!card) return;

  card.querySelector('video')?.pause();
  card.remove();
});

// Accordion toggle
document.addEventListener('DOMContentLoaded', function () {
  function slideUp(el, duration) {
    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
    el.style.transition = 'height ' + duration + 'ms ease';
    requestAnimationFrame(function () {
      el.style.height = '0px';
    });
    setTimeout(function () {
      el.style.display = 'none';
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
    }, duration);
  }

  function slideDown(el, duration) {
    el.style.display = 'block';
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.transition = 'height ' + duration + 'ms ease';
    requestAnimationFrame(function () {
      el.style.height = el.scrollHeight + 'px';
    });
    setTimeout(function () {
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
    }, duration);
  }

  document.querySelectorAll('.accordian-topwrap').forEach(function (title) {
    title.addEventListener('click', function () {
      const self = this;

      // Close all open items except the clicked one
      document.querySelectorAll('.accordian-topwrap.open').forEach(function (open) {
        if (open === self) return;
        open.classList.remove('open');
        open.parentElement.classList.remove('active');
        slideUp(open.nextElementSibling, 300);
      });

      // Toggle clicked item
      const isOpen = self.classList.contains('open');
      self.classList.toggle('open');
      self.parentElement.classList.toggle('active');

      if (isOpen) {
        slideUp(self.nextElementSibling, 300);
      } else {
        slideDown(self.nextElementSibling, 300);
      }
    });
  });

  // Offer code copy button
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.offer-code-button');
    if (!btn) return;

    const code = btn.dataset.code;
    if (!code) return;

    navigator.clipboard.writeText(code).then(function () {
      btn.classList.add('copied');
      setTimeout(function () {
        btn.classList.remove('copied');
      }, 2000);
    }).catch(function (err) {
      console.error('Failed to copy:', err);
    });
  });
});

// GSAP animations — deferred to idle to reduce main-thread pressure at paint time.
// All GSAP elements are below the fold; animations are not visible during initial paint.
// ScrollTrigger.refresh() at the end corrects positions if the browser has scrolled
// before this callback fires.
function _initGsap() {
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray('[gsap-parallax]').forEach(function (element) {
    gsap.to(element, {
      yPercent: -20,
      ease: 'none',
      scrollTrigger: {
        trigger: element,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  });

  gsap.utils.toArray('[gsap-parallax-block]').forEach(function (element) {
    gsap.to(element, {
      yPercent: -50,
      ease: 'none',
      scrollTrigger: {
        trigger: element,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  });

  gsap.utils.toArray('[gsap-fadin-anim]').forEach(function (element) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top 95%',
        end: 'bottom 50%',
        toggleActions: 'play none none none',
      },
    });
    tl.fromTo(
      element,
      { opacity: 0, yPercent: 20 },
      { duration: 1, opacity: 1, yPercent: 0, ease: 'cubic' }
    );
  });

  ScrollTrigger.refresh();
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(_initGsap, { timeout: 2000 });
} else {
  setTimeout(_initGsap, 300);
}
